var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8413 9.37897L15.5306 7.59863C15.2844 7.40923 14.9435 7.57969 14.9435 7.88273V9.05699H11.5722C11.2881 9.05699 11.023 8.92442 10.8714 8.69714L8.86383 5.91299L10.8714 3.12884C11.0419 2.90156 11.3071 2.76898 11.5722 2.76898H14.9435V3.94325C14.9435 4.24628 15.2844 4.41674 15.5306 4.22734L17.8413 2.447C18.0307 2.29548 18.0307 2.01139 17.8413 1.85987L15.5306 0.0795277C15.2844 -0.10987 14.9435 0.0605879 14.9435 0.363625V1.55683H11.5722C10.9093 1.55683 10.2843 1.87881 9.88658 2.42806L8.10624 4.89024L6.32589 2.42806C5.92816 1.87881 5.30314 1.55683 4.64025 1.55683H0.606074C0.265157 1.55683 0 1.82199 0 2.16291C0 2.50382 0.265157 2.76898 0.606074 2.76898H4.65919C4.94329 2.76898 5.20845 2.90156 5.35996 3.12884L7.36758 5.91299L5.35996 8.69714C5.18951 8.92442 4.92435 9.05699 4.65919 9.05699H0.606074C0.265157 9.05699 0 9.32215 0 9.66307C0 10.004 0.265157 10.2691 0.606074 10.2691H4.65919C5.32208 10.2691 5.9471 9.94717 6.34483 9.39791L8.12518 6.93574L9.90552 9.39791C10.3033 9.94717 10.9283 10.2691 11.5912 10.2691H14.9624V11.4434C14.9624 11.7464 15.3034 11.9169 15.5496 11.7275L17.8602 9.94717C18.0496 9.81459 18.0496 9.53049 17.8413 9.37897Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrange);
export default __webpack_public_path__ + "static/media/arrange.f7c003d98548b5b4fba16c7a4dbb68aa.svg";
export { ForwardRef as ReactComponent };